/**
 * The two doors, wired — one file so the pair can be read side by side.
 *
 * Each owns its own step-up dialog and renders it, so nothing downstream has
 * to remember to. `useStepUp` is called at the top of a component in both, as
 * the rules of hooks require; what the context carries is the resulting
 * `guard`, which is an ordinary function.
 */
import { type ReactNode } from 'react'
import { request } from '../lib/api.js'
import { adminRequest } from '../lib/admin-api.js'
import { useStepUp as useTenantStepUp } from '../components/step-up.js'
import { useStepUp as useAdminStepUp } from '../pages/admin/step-up.js'
import { AccountApiProvider, type AccountRequest } from './account-api.js'

/** The office app: `/api/v1/…`, and a password to prove it is you. */
export function TenantAccountApi({ children }: { children: ReactNode }) {
  const stepUp = useTenantStepUp()
  return (
    <AccountApiProvider
      value={{ request: request as AccountRequest, guard: stepUp.guard, side: 'tenant' }}
    >
      {children}
      {stepUp.dialog}
    </AccountApiProvider>
  )
}

/** Rowted Admin: `/api/v1/platform/…`, and a six-digit code. */
export function AdminAccountApi({ children }: { children: ReactNode }) {
  const stepUp = useAdminStepUp()
  return (
    <AccountApiProvider
      value={{ request: adminRequest as AccountRequest, guard: stepUp.guard, side: 'platform' }}
    >
      {children}
      {stepUp.dialog}
    </AccountApiProvider>
  )
}
